export default __webpack_public_path__ + "vietnam-map-500-44a39ac0854f1a86a76e4a98bb067dca.webp";